/**
 * @file sessionOwnership.ts
 * @brief May this viewer delete this session from `/app`? (DES 21-10-2026)
 *
 * @details
 * Only a personal account (no company) and only a session it OWNS. A company
 * employee's data belongs to the company: the server refuses them
 * (`denyCorporateEmployee`, CORPORATE_DATA_GOVERNED), so the menu never shows.
 * The server's own check also lets Person B through (`verifySessionAccess`
 * matches `participant_b_email`), so the owner test here is what keeps B from
 * deleting someone else's session in the app.
 *
 * Pure (no imports) so node:test can load it.
 *
 * @author DES
 * @date 21-10-2026
 */

type Viewer = {
  id?: unknown;
  email?: string | null;
  role?: string | null;
  company_id?: unknown;
  companyId?: unknown;
} | null | undefined;

type SessionOwner = { owner_id?: unknown; owner_email?: string | null } | null | undefined;

export function canDeleteOwnSession(viewer: Viewer, session: SessionOwner): boolean {
  if (!viewer || !session) return false;
  if (viewer.role !== "user") return false;
  if (viewer.company_id ?? viewer.companyId) return false;
  const ownerId = session.owner_id != null ? String(session.owner_id) : "";
  if (ownerId && viewer.id != null) return ownerId === String(viewer.id);
  const ownerEmail = session.owner_email?.trim().toLowerCase();
  const email = viewer.email?.trim().toLowerCase();
  return !!ownerEmail && !!email && ownerEmail === email;
}
